import React, { useEffect, useState } from 'react';
import { Text } from '@chakra-ui/layout';
import Chart from 'react-google-charts';
import { HStack, Spinner } from '@chakra-ui/react';
import { Card } from '~/components/Card';
import { useAccumulatedPaymentChart } from '~/hooks/useStrategicMap';

export default function LoadingDelay(props: any) {
  const { children, delay, fallback } = props;
  const [isShown, setIsShown] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setIsShown(true);
    }, delay);
  }, [delay]);
  return isShown ? children : fallback;
}

export const AccumulatedPaymentChart: React.FC<{
  id_contrato: number;
  data_inicio: string;
  data_extensoes: string[];
  accumulated_key: string;
}> = ({ id_contrato, data_inicio, data_extensoes, accumulated_key }) => {
  const {
    data: dataChart,
    isLoading: isLoadingChart,
    isError: isErrorChart,
    isFetching: isFetchingChart,
  } = useAccumulatedPaymentChart(id_contrato, data_inicio, data_extensoes);
  const circle = (color: string) => {
    return (
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="5" cy="5" r="5" fill={color} />
      </svg>
    );
  };
  const headerPagAccumulated = () => {
    return (
      <HStack
        justifyContent="space-between"
        w="60vw"
        left="8px"
        position="sticky"
      >
        <Text fontWeight="bold">Pagamento acumulado</Text>
        {dataChart && !!dataChart.length && (
          <HStack gridGap={4}>
            <Text display="flex" alignItems="center" gridGap={2}>
              {circle('#1BA65B')} Início do Contrato
            </Text>
            <Text display="flex" alignItems="center" gridGap={2}>
              {circle('#FC8E0E')} Extensão
            </Text>
          </HStack>
        )}
      </HStack>
    );
  };
  return (
    <>
      {dataChart && !dataChart.length ? (
        <Card
          bg="transparent"
          marginTop="10px"
          width="100%"
          minW={dataChart?.length ? `${dataChart.length * 65}px` : '100%'}
          header={headerPagAccumulated()}
          key={accumulated_key}
          content={<Text>Não há dados a serem apresentados</Text>}
        />
      ) : (
        <Card
          bg="transparent"
          marginTop="10px"
          width="100%"
          minW={dataChart?.length ? `${dataChart.length * 65}px` : '100%'}
          header={headerPagAccumulated()}
          key={accumulated_key}
          content={
            <LoadingDelay delay={4000} fallback={<Spinner />}>
              <Chart
                width="100%"
                height="300px"
                chartType="LineChart"
                data={dataChart}
                key={accumulated_key}
                chartLanguage="pt-BR"
                options={{
                  pointsVisible: true,
                  curveType: 'function',
                  series: [{ color: '#2c8ad2' }],
                  legend: { position: 'left' },
                  chartArea: {
                    left: 50,
                    top: 20,
                    bottom: 50,
                    width: '100%',
                    height: '70%',
                  },
                  hAxis: {
                    minValue: 0,
                    textStyle: {
                      fontSize: 10,
                    },
                  },
                  vAxis: {
                    textStyle: {
                      fontSize: 10,
                      color: '#000000',
                    },
                    minValue: 0,
                    format: 'short',
                  },
                  annotations: {
                    textStyle: {
                      fontSize: 8,
                      color: '#000',
                      auraColor: 'none',
                    },
                  },
                  tooltip: { isHtml: true },
                }}
                formatters={[
                  {
                    type: 'NumberFormat' as const,
                    column: 1,
                    options: {
                      decimalSymbol: ',',
                      groupingSymbol: '.',
                      fractionDigits: 0,
                      prefix: 'R$ ',
                    },
                  },
                ]}
              />
            </LoadingDelay>
          }
        />
      )}
    </>
  );
};
